export const posts = [
  {
    id: 'pansori-literature-1',
    date: '2025-01-10',
    title: '판소리와 국문학의 접점: 해학의 미학',
    category: '문화 해석',
    excerpt: '해학은 웃음을 넘어서는 미학적 힘을 갖습니다. 판소리의 언어와 국문학의 수사학은 어디서 만날까요?',
  },
  {
    id: 'vocal-technique-basics',
    date: '2025-02-02',
    title: '기초 발성: 공명과 발음 사이의 균형',
    category: '교육',
    excerpt: '발성과 발음은 같은 축 위에 있습니다. 호흡, 공명, 자음 처리의 균형을 실전 팁과 함께 정리합니다.',
  },
]; 